import React from 'react';
import emfaLogo from '../../public/emfa_logo_web.svg';

export const Logo = ({ className = '' }) => (
  <img
    src={emfaLogo}
    alt="EMFA IT Consulting"
    className={`block w-auto object-contain shrink-0 ${className}`}
  />
);

export default Logo;
